import { defineMessages } from 'react-intl';

export default defineMessages({
    paVehicleLicensePlate: {
        id: 'quoteandbind.pa.directives.templates.pa-edit-vehicle.License Plate',
        defaultMessage: 'License Plate',
    },
    paVehicleLicenseState: {
        id: 'quoteandbind.pa.directives.templates.pa-edit-vehicle.State',
        defaultMessage: 'State',
    },
    paVehicleCostNew: {
        id: 'quoteandbind.pa.directives.templates.pa-edit-vehicle.Cost New',
        defaultMessage: 'Cost New',
    },
});
